import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from '@airasia-common/libraries/i18n/LocaleProvider';
import Row from '../Container/Row';
import { Text } from '../Text';
import Image from '../Image';

const Label = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

const Icon = styled(Image)`
  width: 20px;
  height: 9px;
  margin-right: 5px;
`;

const UnlimitedLabel = ({ isRegular }) => {
  return (
    <Row alignItems="center">
      {isRegular ? (
        <Label color="tertiaryYellow">
          {translate('common.unlimitedDeal.regularFareLabel')}
        </Label>
      ) : (
        <>
          <Icon src="https://static.airasia.com/snap/images/Unlimited.svg" />
          <Label color="#E94335">
            {translate('common.unlimitedDeal.unlimitedLabel')}
          </Label>
        </>
      )}
    </Row>
  );
};

UnlimitedLabel.propTypes = {
  isRegular: PropTypes.bool,
};

export default UnlimitedLabel;
